import React from 'react'
import {useCentralServices} from './useCentralServices'
import {CompanyModel} from '../../../central/model'
import {selectMapperByKeys} from '../../mappers/util'

export const useCompanies = () => {
  const [loading, setLoading] = React.useState(false)
  const [companies, setCompanies] = React.useState<{value: string; label: string}[]>([])
  const {getCompanies} = useCentralServices()

  const getCompaniesFn = async (filters: CompanyModel, page: number) => {
    try {
      setLoading(true)
      const companies = await getCompanies(filters, page)
      const mappedCompanies = selectMapperByKeys(companies, 'id', 'nombreEmpresa')
      const filteredData = mappedCompanies.filter((item) => item.value !== '4EsB2NAAsDA=')
      setCompanies(filteredData)
      return filteredData
    } catch (error) {
      console.error('Error fetching companies:', error)
    } finally {
      setLoading(false)
    }
  }

  const clearCompanies = () => {
    setCompanies([])
  }

  return {
    loading,
    companies,
    getCompanies: getCompaniesFn,
    clearCompanies,
  }
}
